/* =========================================================================
   RAS Express — storefront behaviour
   Vanilla custom elements, no framework. Every interaction degrades to a
   working form/link when JS is unavailable.
   ========================================================================= */
(function () {
  'use strict';

  var RAS = (window.RAS = window.RAS || {});
  RAS.routes = RAS.routes || {};
  RAS.strings = RAS.strings || {};

  /* ---------------------------------------------------------------- utils */
  function money(cents) {
    if (RAS.moneyFormat) {
      // Shopify money formats use {{amount}} style placeholders.
      var value = (cents / 100).toFixed(2);
      var parts = value.split('.');
      var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return RAS.moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + parts[1])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1]);
    }
    return '$' + (cents / 100).toFixed(2);
  }
  RAS.money = money;

  function announce(message, type) {
    var region = document.getElementById('ras-live-region');
    if (region) region.textContent = message;
    if (message) {
      var existing = document.getElementById('ras-toast-notification');
      if (existing) existing.remove();

      var toast = document.createElement('div');
      toast.id = 'ras-toast-notification';
      var isError = type === 'error' || message.toLowerCase().indexOf('sold out') !== -1 || message.toLowerCase().indexOf('error') !== -1 || message.toLowerCase().indexOf('could not') !== -1;
      
      toast.style.cssText = 'position:fixed;top:24px;left:50%;transform:translateX(-50%) translateY(-20px);z-index:100005;padding:12px 20px;background:' + (isError ? '#2c1515' : '#1b3d2b') + ';color:#fff;font-size:14px;font-weight:600;border-radius:10px;box-shadow:0 8px 24px rgba(0,0,0,0.25);display:flex;align-items:center;gap:10px;opacity:0;transition:all 0.25s cubic-bezier(0.16,1,0.3,1);max-width:90vw;text-align:center;pointer-events:none;';
      toast.innerHTML = '<span>' + (isError ? '⚠️' : '✓') + '</span><span>' + message + '</span>';
      document.body.appendChild(toast);

      requestAnimationFrame(function() {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
      });

      setTimeout(function() {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(-50%) translateY(-20px)';
        setTimeout(function() {
          if (toast.parentElement) toast.remove();
        }, 300);
      }, 4000);
    }
  }

  function logSearch(query, resultsCount) {
    if (!RAS.aiProxyUrl) return;
    var searchLogEndpoint = RAS.aiProxyUrl.replace(/\/chat$/, '/search-log');
    
    var sessionId = sessionStorage.getItem('ras-ai-session') ||
      ('sess_' + Math.random().toString(36).slice(2, 9));
    sessionStorage.setItem('ras-ai-session', sessionId);

    fetch(searchLogEndpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Session-Id': sessionId
      },
      body: JSON.stringify({
        query: query,
        results_count: resultsCount
      })
    }).catch(function(err) {
      console.warn('[Search Log] Failed to log storefront search:', err);
    });
  }
  RAS.logSearch = logSearch;

  /* Mobile haptic + sound feedback (Pixel/Android Chrome + iOS).
     Uses short WAV beeps via HTMLAudioElement (most reliable on Chrome),
     with Web Audio as a backup. Sound is NOT gated on reduced-motion. */
  var feedbackAudioCtx = null;
  var feedbackHtmlReady = false;
  var feedbackBeeps = {};

  function isPhoneLikeDevice() {
    var ua = navigator.userAgent || '';
    if (/Android|iPhone|iPad|iPod|Mobile/i.test(ua)) return true;
    try {
      if (window.matchMedia('(hover: none) and (pointer: coarse)').matches) return true;
      if (window.matchMedia('(max-width: 900px)').matches) return true;
    } catch (err) {}
    return window.innerWidth < 900;
  }


  function encodeWavDataUri(freq, durationSec, peak) {
    var sampleRate = 22050;
    var count = Math.max(1, Math.floor(sampleRate * durationSec));
    var dataSize = count * 2;
    var buffer = new ArrayBuffer(44 + dataSize);
    var view = new DataView(buffer);
    var writeStr = function (offset, str) {
      for (var i = 0; i < str.length; i++) view.setUint8(offset + i, str.charCodeAt(i));
    };
    writeStr(0, 'RIFF');
    view.setUint32(4, 36 + dataSize, true);
    writeStr(8, 'WAVE');
    writeStr(12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    writeStr(36, 'data');
    view.setUint32(40, dataSize, true);

    var amp = typeof peak === 'number' ? peak : 0.55;
    for (var i = 0; i < count; i++) {
      var t = i / sampleRate;
      var attack = Math.min(1, i / 120);
      var release = Math.min(1, (count - i) / 500);
      var sample = Math.sin(2 * Math.PI * freq * t) * amp * attack * release;
      view.setInt16(44 + i * 2, Math.max(-1, Math.min(1, sample)) * 0x7fff, true);
    }

    var bytes = new Uint8Array(buffer);
    var binary = '';
    for (var j = 0; j < bytes.length; j++) binary += String.fromCharCode(bytes[j]);
    return 'data:audio/wav;base64,' + btoa(binary);
  }

  function getBeep(name, freq, durationSec, peak) {
    if (feedbackBeeps[name]) return feedbackBeeps[name];
    try {
      var audio = new Audio(encodeWavDataUri(freq, durationSec, peak));
      audio.preload = 'auto';
      audio.setAttribute('playsinline', 'true');
      audio.volume = 1;
      feedbackBeeps[name] = audio;
      return audio;
    } catch (err) {
      return null;
    }
  }

  function unlockHtmlBeeps() {
    if (!isPhoneLikeDevice()) return;
    var samples = [
      getBeep('tap', 540, 0.06, 0.6),
      getBeep('add1', 700, 0.07, 0.65),
      getBeep('add2', 940, 0.09, 0.55),
      getBeep('remove', 300, 0.08, 0.55)
    ];
    samples.forEach(function (audio) {
      if (!audio) return;
      try {
        audio.muted = true;
        var playPromise = audio.play();
        var finish = function () {
          try {
            audio.pause();
            audio.currentTime = 0;
            audio.muted = false;
            feedbackHtmlReady = true;
          } catch (err) { /* ignore */ }
        };
        if (playPromise && playPromise.then) playPromise.then(finish).catch(function () {});
        else finish();
      } catch (err) { /* ignore */ }
    });
  }

  function playHtmlBeep(name) {
    var audio = feedbackBeeps[name];
    if (!audio) return false;
    try {
      audio.muted = false;
      audio.volume = 1;
      if (audio.currentTime > 0) audio.currentTime = 0;
      var playPromise = audio.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(function () {
          /* Clone fallback if the element is busy / blocked */
          try {
            var clone = audio.cloneNode();
            clone.volume = 1;
            clone.play().catch(function () {});
          } catch (err) { /* ignore */ }
        });
      }
      return true;
    } catch (err) {
      return false;
    }
  }

  function getFeedbackAudioCtx() {
    if (feedbackAudioCtx) return feedbackAudioCtx;
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      feedbackAudioCtx = new Ctx();
    } catch (err) {
      feedbackAudioCtx = null;
    }
    return feedbackAudioCtx;
  }

  function kickAudioUnlock(ctx) {
    try {
      var buffer = ctx.createBuffer(1, 1, ctx.sampleRate || 22050);
      var source = ctx.createBufferSource();
      source.buffer = buffer;
      source.connect(ctx.destination);
      source.start(0);
    } catch (err) { /* ignore */ }
  }

  function unlockWebAudio() {
    var ctx = getFeedbackAudioCtx();
    if (!ctx) return;
    try {
      if (ctx.state === 'suspended') ctx.resume();
      kickAudioUnlock(ctx);
    } catch (err) { /* ignore */ }
  }

  function playWebTone(freq, duration, type, gainValue) {
    var ctx = getFeedbackAudioCtx();
    if (!ctx) return;
    try {
      if (ctx.state === 'suspended') ctx.resume();
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      var vol = typeof gainValue === 'number' ? gainValue : 0.12;
      var now = ctx.currentTime;
      osc.type = type || 'sine';
      osc.frequency.setValueAtTime(freq, now);
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(vol, now + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + Math.max(duration, 0.05));
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(now);
      osc.stop(now + duration + 0.05);
    } catch (err) { /* ignore */ }
  }

  function vibrate(pattern) {
    if (!isPhoneLikeDevice()) return;
    try {
      if (navigator.vibrate) navigator.vibrate(pattern);
    } catch (err) { /* ignore */ }
  }

  function feedbackTap() {
    if (!isPhoneLikeDevice()) return;
    vibrate(12);
    if (!playHtmlBeep('tap')) playWebTone(540, 0.055, 'triangle', 0.12);
  }

  function feedbackAdd() {
    if (!isPhoneLikeDevice()) return;
    vibrate([16, 28, 24]);
    if (!playHtmlBeep('add1')) playWebTone(700, 0.06, 'sine', 0.14);
    window.setTimeout(function () {
      if (!playHtmlBeep('add2')) playWebTone(940, 0.08, 'sine', 0.12);
    }, 70);
  }

  function feedbackRemove() {
    if (!isPhoneLikeDevice()) return;
    vibrate([10, 18, 10]);
    if (!playHtmlBeep('remove')) playWebTone(300, 0.07, 'triangle', 0.12);
  }

  RAS.feedback = { tap: feedbackTap, add: feedbackAdd, remove: feedbackRemove };

  function onFeedbackGesture() {
    if (!isPhoneLikeDevice()) return;
    unlockHtmlBeeps();
    unlockWebAudio();
  }

  document.addEventListener('touchstart', onFeedbackGesture, { capture: true, passive: true });
  document.addEventListener('pointerdown', onFeedbackGesture, { capture: true, passive: true });
  document.addEventListener('click', onFeedbackGesture, { capture: true, passive: true });

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw data;
        return data;
      });
    });
  }

  /* Broadcast so every cart-aware element refreshes from one source. */
  function publishCart(cart) {
    document.dispatchEvent(new CustomEvent('ras:cart:update', { detail: { cart: cart } }));
  }

  RAS.getCart = function () {
    return fetchJSON(RAS.routes.cart_url + '.js').then(function (cart) {
      publishCart(cart);
      return cart;
    });
  };

  RAS.addToCart = function (payload) {
    return fetchJSON(RAS.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function () {
      return RAS.getCart();
    });
  };

  RAS.changeLine = function (key, quantity) {
    return fetchJSON(RAS.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (cart) {
      publishCart(cart);
      return cart;
    });
  };

  /* --------------------------------------------------------- cart counters */
  function syncViewCartPill(count) {
    var isCartPage = document.body.classList.contains('template-cart');
    var show = count > 0 && !isCartPage;
    document.body.classList.toggle('has-view-cart', show);
    document.querySelectorAll('[data-view-cart]').forEach(function (pill) {
      pill.hidden = !show;
      pill.setAttribute(
        'aria-label',
        (pill.querySelector('.ras-view-cart__label')
          ? pill.querySelector('.ras-view-cart__label').textContent
          : 'View cart') +
          ' · ' +
          count
      );
      if (show) {
        pill.classList.remove('is-view-cart-in');
        void pill.offsetWidth;
        pill.classList.add('is-view-cart-in');
      }
    });
  }

  document.addEventListener('ras:cart:update', function (event) {
    var count = event.detail.cart.item_count;
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      var prev = Number(node.textContent) || 0;
      var wasHidden = node.hidden;
      node.hidden = count === 0;
      node.textContent = count;

      if (count > 0 && (count !== prev || wasHidden)) {
        node.classList.remove('is-count-pop');
        void node.offsetWidth;
        node.classList.add('is-count-pop');
        if (count > prev) spawnPlusBurst(node, count - prev);
      }
    });
    document.querySelectorAll('[data-cart-count-text]').forEach(function (node) {
      node.textContent = count;
    });
    syncViewCartPill(count);
  });

  /* Grocery-style fly-to-cart — transform-only for reliable mobile Safari */
  function isFlyTargetVisible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    try {
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
    } catch (err) {
      return false;
    }
    var rect = el.getBoundingClientRect();
    return rect.width > 2 && rect.height > 2;
  }

  function getCartTarget() {
    var candidates = [
      document.querySelector('.ras-appbar__cart[data-cart-target]'),
      document.querySelector('.ras-header [data-cart-target], .ras-header .ras-cart-button'),
      document.querySelector('[data-view-cart]:not([hidden])'),
      document.querySelector('.ras-tabbar [data-cart-target]'),
      document.querySelector('[data-cart-target]'),
      document.querySelector('.ras-tabbar [data-cart-count]')
        ? document.querySelector('.ras-tabbar [data-cart-count]').closest('.ras-tabbar__item')
        : null,
      document.querySelector('.ras-tabbar a[href*="/cart"]'),
      document.querySelector('[data-drawer-open]')
    ];

    for (var i = 0; i < candidates.length; i++) {
      if (isFlyTargetVisible(candidates[i])) return candidates[i];
    }
    return null;
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      return false;
    }
  }

  function ensureFlyRoot() {
    var root = document.getElementById('ras-fly-root');
    if (root) return root;
    root = document.createElement('div');
    root.id = 'ras-fly-root';
    root.setAttribute('aria-hidden', 'true');
    root.style.cssText =
      'position:fixed;inset:0;z-index:2147483000;pointer-events:none;overflow:visible;';
    document.body.appendChild(root);
    return root;
  }

  function spawnPlusBurst(anchor, amount) {
    if (!anchor) return;
    var host = anchor.closest('.ras-tabbar__item') || anchor;
    var rect = host.getBoundingClientRect();
    var burst = document.createElement('div');
    burst.className = 'ras-cart-plus';
    burst.setAttribute('aria-hidden', 'true');
    burst.textContent = '+' + amount;
    burst.style.cssText =
      'position:fixed;left:' +
      (rect.left + rect.width / 2) +
      'px;top:' +
      (rect.top - 4) +
      'px;z-index:2147483001;transform:translate(-50%,-100%);pointer-events:none;font-weight:800;font-size:16px;color:#B49310;';
    ensureFlyRoot().appendChild(burst);
    window.setTimeout(function () {
      if (burst.parentNode) burst.parentNode.removeChild(burst);
    }, 1000);
  }

  function flyToCart(fromEl) {
    var cartTarget = getCartTarget();
    var origin = fromEl;

    if (!origin || !origin.getBoundingClientRect) {
      bumpCart(cartTarget);
      return Promise.resolve();
    }

    // Always give immediate cart feedback on mobile, even if the flyer fails.
    bumpCart(cartTarget);

    var reduced = prefersReducedMotion();
    var from = origin.getBoundingClientRect();
    var to = cartTarget
      ? cartTarget.getBoundingClientRect()
      : { left: window.innerWidth - 48, top: window.innerHeight - 48, width: 40, height: 40 };

    if (from.width < 1 || from.height < 1) {
      from = {
        left: window.innerWidth / 2 - 20,
        top: window.innerHeight / 2 - 20,
        width: 40,
        height: 40
      };
    }

    var startX = from.left + from.width / 2;
    var startY = from.top + from.height / 2;
    var endX = to.left + to.width / 2;
    var endY = to.top + to.height / 2;
    var dx = endX - startX;
    var dy = endY - startY;
    var lift = Math.max(110, Math.min(200, Math.abs(dx) * 0.28 + 90));
    var midX = dx * 0.5;
    var midY = Math.min(0, dy * 0.2) - lift;
    var duration = reduced ? 550 : 1250;

    try {
      origin.classList.add('is-add-pulse');
      window.setTimeout(function () {
        origin.classList.remove('is-add-pulse');
      }, 420);
    } catch (err) { /* ignore */ }

    var root = ensureFlyRoot();
    var flyer = document.createElement('div');
    flyer.className = 'ras-fly-item';
    flyer.setAttribute('aria-hidden', 'true');
    flyer.innerHTML =
      '<span class="ras-fly-item__ring"></span><span class="ras-fly-item__dot"></span>';

    // Inline styles so the flyer is visible even if CSS cache is stale.
    flyer.style.cssText = [
      'position:fixed',
      'left:' + startX + 'px',
      'top:' + startY + 'px',
      'width:42px',
      'height:42px',
      'margin:0',
      'padding:0',
      'z-index:2147483000',
      'pointer-events:none',
      'opacity:1',
      'transform:translate3d(-50%,-50%,0) scale(0.6)',
      'will-change:transform,opacity',
      '-webkit-backface-visibility:hidden',
      'backface-visibility:hidden'
    ].join(';');

    root.appendChild(flyer);

    // Pure pixel translate3d — most reliable on iOS Safari.
    var keyframes = [
      { transform: 'translate3d(-21px,-21px,0) scale(0.55)', opacity: 0.0 },
      { transform: 'translate3d(-21px,-21px,0) scale(1.2)', opacity: 1, offset: 0.12 },
      {
        transform: 'translate3d(' + (midX - 21) + 'px,' + (midY - 21) + 'px,0) scale(1.05)',
        opacity: 1,
        offset: 0.48
      },
      {
        transform: 'translate3d(' + (dx - 21) + 'px,' + (dy - 21) + 'px,0) scale(0.18)',
        opacity: 0.05
      }
    ];

    function cleanup() {
      if (flyer && flyer.parentNode) flyer.parentNode.removeChild(flyer);
      bumpCart(cartTarget);
    }

    if (typeof flyer.animate === 'function') {
      try {
        var anim = flyer.animate(keyframes, {
          duration: duration,
          easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
          fill: 'forwards'
        });
        return anim.finished.then(cleanup).catch(cleanup);
      } catch (err) {
        /* fall through to rAF */
      }
    }

    // rAF fallback (transform-only)
    return new Promise(function (resolve) {
      var start = null;
      function ease(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }
      function bez(a, b, c, t) {
        var u = 1 - t;
        return u * u * a + 2 * u * t * b + t * t * c;
      }
      function frame(now) {
        if (start === null) start = now;
        var raw = Math.min(1, (now - start) / duration);
        var t = ease(raw);
        var x = bez(0, midX, dx, t) - 21;
        var y = bez(0, midY, dy, t) - 21;
        var scale = raw < 0.12 ? 0.55 + (raw / 0.12) * 0.65 : raw > 0.8 ? 1.05 - ((raw - 0.8) / 0.2) * 0.87 : 1.05;
        var opacity = raw < 0.08 ? raw / 0.08 : raw > 0.9 ? Math.max(0, (1 - raw) / 0.1) : 1;
        flyer.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) scale(' + scale + ')';
        flyer.style.opacity = String(opacity);
        if (raw < 1) requestAnimationFrame(frame);
        else {
          cleanup();
          resolve();
        }
      }
      requestAnimationFrame(frame);
    });
  }

  function bumpCart(cartTarget) {
    var target = cartTarget || getCartTarget();
    if (!target) return;
    target.classList.remove('is-cart-bump');
    void target.offsetWidth;
    target.classList.add('is-cart-bump');
    window.setTimeout(function () {
      target.classList.remove('is-cart-bump');
    }, 700);
  }

  RAS.flyToCart = flyToCart;

  /* ------------------------------------------------------------ cart drawer */
  var CartDrawer = /** @class */ (function () {
    function CartDrawer(el) {
      this.el = el;
      this.panel = el.querySelector('.ras-drawer__panel');
      this.lastFocused = null;

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-drawer-close]') || event.target.matches('.ras-drawer__overlay')) {
          this.close();
        }
      }.bind(this));

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && this.isOpen()) this.close();
      }.bind(this));

      document.addEventListener('ras:cart:update', this.render.bind(this));
      document.addEventListener('ras:drawer:open', this.open.bind(this));
    }
    CartDrawer.prototype.isOpen = function () {
      return this.el.classList.contains('is-open');
    };
    CartDrawer.prototype.open = function () {
      this.lastFocused = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-drawer-open');
      document.body.style.overflow = 'hidden';
      var focusable = this.panel.querySelector('[data-drawer-close]');
      if (focusable) focusable.focus();
    };
    CartDrawer.prototype.close = function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-drawer-open');
      document.body.style.overflow = '';
      if (this.lastFocused) this.lastFocused.focus();
    };
    /* Re-render from the section rendering API so markup stays in Liquid. */
    CartDrawer.prototype.render = function () {
      var self = this;
      return fetch(RAS.routes.cart_url + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-drawer-contents]');
          var current = self.el.querySelector('[data-drawer-contents]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        })
        .catch(function () { /* leave the existing markup in place */ });
    };
    return CartDrawer;
  })();

  /* ---------------------------------------------------------- mobile menu */
  var MobileMenu = /** @class */ (function () {
    function MobileMenu(el) {
      this.el = el;
      this.panel = el.querySelector('.ras-menu__panel');
      this.triggers = document.querySelectorAll('[data-menu-open]');
      this.lastFocused = null;
      var self = this;

      this.triggers.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          self.open();
        });
      });

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-menu-close]')) self.close();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && self.isOpen()) self.close();
      });

      document.addEventListener('ras:menu:open', this.open.bind(this));
      document.addEventListener('ras:menu:close', this.close.bind(this));
      document.addEventListener('ras:drawer:open', this.close.bind(this));
    }
    MobileMenu.prototype.isOpen = function () {
      return this.el.classList.contains('is-open');
    };
    MobileMenu.prototype.open = function () {
      this.lastFocused = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ras-menu-open');
      document.body.style.overflow = 'hidden';
      this.triggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      var focusable = this.panel && this.panel.querySelector('[data-menu-close]');
      if (focusable) focusable.focus();
    };
    MobileMenu.prototype.close = function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ras-menu-open');
      document.body.style.overflow = '';
      this.triggers.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      if (this.lastFocused) this.lastFocused.focus();
    };
    return MobileMenu;
  })();

  /* --------------------------------------------------- sold out management */
  function markVariantSoldOut(variantId) {
    if (!variantId) return;
    try {
      sessionStorage.setItem('ras_soldout_' + variantId, 'true');
    } catch (e) {}

    // Replace + button on cards with Sold out pill
    document.querySelectorAll('[data-quick-add][data-variant-id="' + variantId + '"]').forEach(function (btn) {
      var soldOutSpan = document.createElement('span');
      soldOutSpan.className = 'ras-card__add is-sold-out';
      soldOutSpan.setAttribute('aria-hidden', 'true');
      soldOutSpan.textContent = 'Sold out';
      if (btn.parentNode) btn.parentNode.replaceChild(soldOutSpan, btn);
    });

    // Update buy forms
    document.querySelectorAll('form').forEach(function (form) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && String(idInput.value) === String(variantId)) {
        var submitBtn = form.querySelector('[data-add-to-cart]');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-sold-out');
          submitBtn.innerHTML = '<span>Sold out</span>';
          submitBtn.style.background = '#f3f3f3';
          submitBtn.style.color = '#888';
          submitBtn.style.borderColor = '#e0e0e0';
          submitBtn.style.cursor = 'not-allowed';
          submitBtn.style.boxShadow = 'none';
        }
        var qtyWrapper = form.querySelector('.ras-qty');
        if (qtyWrapper) qtyWrapper.style.display = 'none';
      }
    });
  }
  RAS.markVariantSoldOut = markVariantSoldOut;

  function syncSoldOutElements(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-quick-add][data-variant-id]').forEach(function (el) {
      var vid = el.getAttribute('data-variant-id');
      if (vid && sessionStorage.getItem('ras_soldout_' + vid) === 'true') {
        markVariantSoldOut(vid);
      }
    });
    scope.querySelectorAll('form input[name="id"]').forEach(function (input) {
      var vid = input.value;
      if (vid && sessionStorage.getItem('ras_soldout_' + vid) === 'true') {
        markVariantSoldOut(vid);
      }
    });
  }
  RAS.syncSoldOutElements = syncSoldOutElements;

  /* ------------------------------------------------------------ quick add */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quick-add]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.setAttribute('aria-busy', 'true');
    feedbackAdd();
    flyToCart(button);
    RAS.addToCart({ items: [{ id: Number(variantId), quantity: 1 }] })
      .then(function () {
        announce(RAS.strings.added_to_cart || 'Added to cart');
        document.dispatchEvent(new CustomEvent('ras:drawer:open'));
      })
      .catch(function (error) {
        console.error('Quick add error:', error);
        var msg = (error && error.description) || (error && error.message) || RAS.strings.cart_error || 'Could not add to cart';
        if (msg.toLowerCase().indexOf('sold out') !== -1 || (error && error.status === 422)) {
          markVariantSoldOut(variantId);
        }
        announce(msg, 'error');
      })
      .finally(function () {
        button.removeAttribute('aria-busy');
      });
  });

  /* ------------------------------------------------------- product form */
  /* Always AJAX-add so grocery shopping can keep flowing with fly-to-cart. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-product-form]');
    if (!form) return;

    event.preventDefault();
    var button = form.querySelector('[data-add-to-cart]');
    if (button) button.setAttribute('aria-busy', 'true');

    var origin =
      button ||
      document.querySelector('.ras-gallery__main img') ||
      document.querySelector('.ras-product img');

    feedbackAdd();
    flyToCart(origin);

    fetchJSON(RAS.routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function () {
        return RAS.getCart();
      })
      .then(function () {
        announce(RAS.strings.added_to_cart || 'Added to cart');
        
        var qvModal = document.getElementById('ras-quick-view-modal');
        if (qvModal && qvModal.classList.contains('is-open')) {
          if (button) {
            button.classList.add('is-added-success');
            var prevHtml = button.innerHTML;
            button.innerHTML = '<span>Added! ✓</span>';
          }
          setTimeout(function() {
            qvModal.classList.remove('is-open');
            document.body.classList.remove('quick-view-open');
            qvModal.setAttribute('aria-hidden', 'true');
            document.dispatchEvent(new CustomEvent('ras:drawer:open'));
          }, 350);
        } else {
          document.dispatchEvent(new CustomEvent('ras:drawer:open'));
        }
      })
      .catch(function (error) {
        console.error('Add to cart error:', error);
        var idInput = form.querySelector('[name="id"]');
        var variantId = idInput ? idInput.value : null;
        var msg = (error && error.description) || (error && error.message) || RAS.strings.cart_error || 'Could not add to cart';
        if (msg.toLowerCase().indexOf('sold out') !== -1 || (error && error.status === 422)) {
          if (variantId) markVariantSoldOut(variantId);
        }
        announce(msg, 'error');
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
      });
  });

  /* --------------------------------------------------- cart line quantity */
  function syncQtyChrome(wrapper, qty) {
    if (!wrapper) return;
    var down = wrapper.querySelector('[data-qty-step="down"]');
    if (!down) return;
    var isTrash = qty <= 1;
    down.classList.toggle('is-trash', isTrash);
    down.setAttribute('aria-label', isTrash ? 'Remove' : 'Decrease quantity');
  }

  function syncCartPageTotals(cart) {
    var subtotal = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    document.querySelectorAll('[data-cart-subtotal]').forEach(function (node) {
      node.textContent = money(subtotal);
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (node) {
      node.textContent = money(cart.total_price);
    });
    if (document.body.classList.contains('template-cart') && cart.item_count === 0) {
      window.location.reload();
    }
  }

  document.addEventListener('click', function (event) {
    var step = event.target.closest('[data-qty-step]');
    if (!step) return;
    var wrapper = step.closest('.ras-qty');
    var input = wrapper.querySelector('input');
    var delta = step.getAttribute('data-qty-step') === 'up' ? 1 : -1;
    var next = Math.max(Number(input.min || 0), Number(input.value) + delta);
    if (String(next) === input.value) return;
    if (next === 0 || (delta < 0 && next <= 1 && step.classList.contains('is-trash'))) {
      feedbackRemove();
    } else {
      feedbackTap();
    }
    input.value = next;
    syncQtyChrome(wrapper, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-line-key]');
    if (!input) return;
    var key = input.getAttribute('data-line-key');
    var qty = Number(input.value);
    var line = input.closest('[data-line-item]');
    var wrapper = input.closest('.ras-qty');
    syncQtyChrome(wrapper, qty);
    RAS.changeLine(key, qty)
      .then(function (cart) {
        if (qty === 0 && line) line.remove();
        syncCartPageTotals(cart);
      })
      .catch(function () {
        announce(RAS.strings.cart_error || 'Could not update cart');
      });
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-line-remove]');
    if (!remove) return;
    event.preventDefault();
    var line = remove.closest('[data-line-item]');
    RAS.changeLine(remove.getAttribute('data-line-remove'), 0)
      .then(function (cart) {
        if (line) line.remove();
        syncCartPageTotals(cart);
      })
      .catch(function () {
        announce(RAS.strings.cart_error || 'Could not update cart');
      });
  });

  document.addEventListener('ras:cart:update', function (event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    (cart.items || []).forEach(function (item) {
      var line = document.querySelector('[data-line-item="' + item.key + '"]');
      if (!line) return;
      var input = line.querySelector('[data-line-key]');
      if (input && Number(input.value) !== item.quantity) {
        input.value = item.quantity;
        syncQtyChrome(input.closest('.ras-qty'), item.quantity);
      }
      var price = line.querySelector('[data-line-price]');
      if (price) price.textContent = money(item.final_line_price);
    });
    syncCartPageTotals(cart);
  });

  /* -------------------------------------------------------- hero slideshow */
  var HeroSlideshow = /** @class */ (function () {
    function HeroSlideshow(el) {
      this.el = el;
      this.slides = Array.prototype.slice.call(el.querySelectorAll('[data-slide]'));
      this.dots = Array.prototype.slice.call(el.querySelectorAll('[data-slide-dot]'));
      this.index = 0;
      this.interval = Number(el.getAttribute('data-autoplay')) || 0;
      this.timer = null;

      if (this.slides.length < 2) return;

      this.dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          this.go(i);
          this.stop();
          this.start();
        }.bind(this));
      }.bind(this));

      el.addEventListener('mouseenter', this.stop.bind(this));
      el.addEventListener('mouseleave', this.start.bind(this));
      el.addEventListener('focusin', this.stop.bind(this));
      el.addEventListener('focusout', this.start.bind(this));

      this.bindSwipe();
      this.start();
    }
    HeroSlideshow.prototype.bindSwipe = function () {
      var self = this;
      var startX = 0;
      var startY = 0;
      var tracking = false;
      var axis = null;

      function onStart(x, y) {
        tracking = true;
        axis = null;
        startX = x;
        startY = y;
        self.stop();
      }

      function onMove(x, y) {
        if (!tracking) return;
        if (axis) return;
        var dx = x - startX;
        var dy = y - startY;
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      function onEnd(x) {
        if (!tracking) return;
        tracking = false;
        if (axis === 'x') {
          var dx = x - startX;
          if (Math.abs(dx) >= 42) {
            self.go(self.index + (dx < 0 ? 1 : -1));
          }
        }
        axis = null;
        self.start();
      }

      this.el.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        onStart(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });

      this.el.addEventListener('touchmove', function (event) {
        if (!event.touches || event.touches.length !== 1) return;
        onMove(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });

      this.el.addEventListener('touchend', function (event) {
        var touch = event.changedTouches && event.changedTouches[0];
        onEnd(touch ? touch.clientX : startX);
      }, { passive: true });

      this.el.addEventListener('touchcancel', function () {
        tracking = false;
        axis = null;
        self.start();
      }, { passive: true });

      // Pointer drag for desktop / stylus too
      var pointerId = null;
      this.el.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, label')) return;
        pointerId = event.pointerId;
        onStart(event.clientX, event.clientY);
        try { self.el.setPointerCapture(event.pointerId); } catch (err) { /* ignore */ }
      });

      this.el.addEventListener('pointermove', function (event) {
        if (pointerId !== event.pointerId) return;
        onMove(event.clientX, event.clientY);
      });

      function endPointer(event) {
        if (pointerId !== event.pointerId) return;
        pointerId = null;
        onEnd(event.clientX);
      }

      this.el.addEventListener('pointerup', endPointer);
      this.el.addEventListener('pointercancel', endPointer);
    };
    HeroSlideshow.prototype.go = function (i) {
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides.forEach(function (slide, n) {
        slide.setAttribute('aria-hidden', n === this.index ? 'false' : 'true');
        slide.querySelectorAll('a, button').forEach(function (node) {
          node.tabIndex = n === this.index ? 0 : -1;
        }.bind(this));
      }.bind(this));
      this.dots.forEach(function (dot, n) {
        dot.setAttribute('aria-current', n === this.index ? 'true' : 'false');
      }.bind(this));
    };
    HeroSlideshow.prototype.start = function () {
      if (!this.interval) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.stop();
      this.timer = setInterval(function () { this.go(this.index + 1); }.bind(this), this.interval);
    };
    HeroSlideshow.prototype.stop = function () {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    };
    return HeroSlideshow;
  })();

  /* ------------------------------------------------- product variant picker */
  var VariantPicker = /** @class */ (function () {
    function VariantPicker(el) {
      this.el = el;
      this.form = el.closest('form') || document.querySelector('[data-product-form]');
      this.idInput = this.form ? this.form.querySelector('[data-variant-id-input]') : null;
      this.priceTarget = document.querySelector('[data-product-price]');
      this.submit = this.form ? this.form.querySelector('[data-add-to-cart]') : null;
      this.variants = JSON.parse(el.querySelector('[data-variant-data]').textContent);

      el.addEventListener('change', this.onChange.bind(this));
    }
    VariantPicker.prototype.selectedOptions = function () {
      return Array.prototype.slice
        .call(this.el.querySelectorAll('input[type="radio"]:checked, select'))
        .map(function (node) { return node.value; });
    };
    VariantPicker.prototype.onChange = function (event) {
      var selected = this.selectedOptions();
      var match = this.variants.find(function (variant) {
        return variant.options.every(function (option, i) { return option === selected[i]; });
      });

      if (event && event.target && event.target.closest) {
        var fieldset = event.target.closest('.ras-variant');
        var valueNode = fieldset && fieldset.querySelector('.ras-variant__legend-value');
        if (valueNode && event.target.value) valueNode.textContent = event.target.value;
      }

      if (this.idInput) this.idInput.value = match ? match.id : '';

      if (this.priceTarget && match) {
        this.priceTarget.innerHTML =
          '<span class="ras-price">' + money(match.price) + '</span>' +
          (match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s>' : '');
      }

      var available = match && match.available;
      var buybox = this.form ? this.form.querySelector('[data-buybox]') : null;
      var soldOutBanner = this.form ? this.form.querySelector('[data-sold-out-banner]') : null;

      if (buybox) {
        buybox.style.display = available ? 'flex' : 'none';
      }
      if (soldOutBanner) {
        soldOutBanner.style.display = available ? 'none' : 'inline-flex';
      }

      if (this.submit) {
        this.submit.disabled = !available;
        this.submit.textContent = available
          ? RAS.strings.add_to_cart || 'Add to cart'
          : match
            ? RAS.strings.sold_out || 'Sold out'
            : RAS.strings.unavailable || 'Unavailable';
      }

      if (match && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }

      /* Jump the gallery to the variant's image when it has one. */
      if (match && match.featured_media_id) {
        var thumb = document.querySelector('[data-gallery-thumb][data-media-id="' + match.featured_media_id + '"]');
        if (thumb) thumb.click();
      }
    };
    return VariantPicker;
  })();

  /* ------------------------------------------------------- product gallery */
  var Gallery = /** @class */ (function () {
    function Gallery(el) {
      this.el = el;
      this.main = el.querySelector('[data-gallery-main]');
      el.addEventListener('click', function (event) {
        var thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        event.preventDefault();
        el.querySelectorAll('[data-gallery-thumb]').forEach(function (node) {
          node.setAttribute('aria-current', node === thumb ? 'true' : 'false');
        });
        var img = thumb.querySelector('img');
        var full = this.main ? this.main.querySelector('img') : null;
        if (img && full) {
          full.src = thumb.getAttribute('data-full') || img.src;
          full.removeAttribute('srcset');
          full.alt = img.alt;
        }
      }.bind(this));
    }
    return Gallery;
  })();

  /* ---------------------------------------------- product-grid filter tabs */
  var FilterTabs = /** @class */ (function () {
    function FilterTabs(el) {
      this.el = el;
      this.step = Number(el.getAttribute('data-page-size')) || 8;
      this.shown = this.step;
      this.filter = 'all';
      this.items = Array.prototype.slice.call(el.querySelectorAll('[data-group]'));
      this.more = el.querySelector('[data-load-more]');

      el.querySelectorAll('[data-filter]').forEach(function (button) {
        button.addEventListener('click', function () {
          el.querySelectorAll('[data-filter]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
          button.setAttribute('aria-pressed', 'true');
          this.filter = button.getAttribute('data-filter');
          this.shown = this.step;
          this.apply();
        }.bind(this));
      }.bind(this));

      if (this.more) {
        this.more.addEventListener('click', function () {
          this.shown += this.step;
          this.apply();
        }.bind(this));
      }

      this.apply();
    }
    FilterTabs.prototype.matching = function () {
      return this.items.filter(function (item) {
        return this.filter === 'all' || item.getAttribute('data-group') === this.filter;
      }.bind(this));
    };
    FilterTabs.prototype.apply = function () {
      var matching = this.matching();
      this.items.forEach(function (item) { item.hidden = true; });
      matching.slice(0, this.shown).forEach(function (item) { item.hidden = false; });

      var remaining = matching.length - Math.min(this.shown, matching.length);
      if (this.more) {
        this.more.hidden = remaining <= 0;
        var label = this.more.querySelector('[data-remaining]');
        if (label) label.textContent = remaining;
      }
      var empty = this.el.querySelector('[data-filter-empty]');
      if (empty) empty.hidden = matching.length > 0;
    };
    return FilterTabs;
  })();

  /* ----------------------------------------------------- collection facets */
  /* Auto-submits the filter form so checkboxes behave like a live filter,
     while the form still works as a plain GET submit without JS. */
  var FacetForm = /** @class */ (function () {
    function FacetForm(el) {
      el.addEventListener('change', function () {
        var params = new URLSearchParams(new FormData(el));
        // Drop empty values so the URL stays readable.
        var clean = new URLSearchParams();
        params.forEach(function (value, key) { if (value) clean.append(key, value); });
        window.location.search = clean.toString();
      });
    }
    return FacetForm;
  })();

  /* ----------------------------------------------------------- sticky-safe */
  /* Close any open <details> dropdown when clicking elsewhere. */
  document.addEventListener('click', function (event) {
    document.querySelectorAll('details.ras-facet[open]').forEach(function (details) {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  /* ------------------------------------------------- product recommendations */
  var Recommendations = /** @class */ (function () {
    function Recommendations(el) {
      var url = el.getAttribute('data-url');
      if (!url) return;
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-recommendations]');
          if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
        })
        .catch(function () { el.remove(); });
    }
    return Recommendations;
  })();

  /* --------------------------------------------- Instacart-style search */
  var SearchDiscover = /** @class */ (function () {
    function SearchDiscover(el) {
      /* Escape sticky header stacking context so we sit above floating cart */
      if (el.parentNode !== document.body) {
        document.body.appendChild(el);
      }
      this.el = el;
      this.input = el.querySelector('[data-search-discover-input]');
      this.form = el.querySelector('[data-search-discover-form]');
      this.idle = el.querySelector('[data-search-idle]');
      this.results = el.querySelector('[data-search-results]');
      this.resultsList = el.querySelector('[data-search-results-list]');
      this.resultsLabel = el.querySelector('[data-search-results-label]');
      this.seeAll = el.querySelector('[data-search-see-all]');
      this.clearBtn = el.querySelector('[data-search-clear]');
      this.timer = null;
      this.lastFocused = null;
      var self = this;

      document.addEventListener('click', function (event) {
        var openTrigger = event.target.closest('[data-search-open]');
        if (openTrigger) {
          event.preventDefault();
          event.stopPropagation();
          document.dispatchEvent(new CustomEvent('ras:menu:close'));
          self.open(openTrigger.value || openTrigger.getAttribute('data-search-term') || '');
          return;
        }
        if (event.target.closest('[data-search-open-form]') && event.target.matches('input, .ras-appbar__search, .ras-appbar__search *')) {
          var field = event.target.closest('form') && event.target.closest('form').querySelector('[data-search-open]');
          if (field) {
            event.preventDefault();
            self.open(field.value || '');
          }
        }
      }, true);

      document.addEventListener('focusin', function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-search-open]')) {
          event.target.blur();
          self.open(event.target.value || '');
        }
      });

      el.addEventListener('click', function (event) {
        if (event.target.closest('[data-search-close]')) {
          self.close();
          return;
        }
        if (event.target.closest('[data-search-clear]')) {
          if (self.input) {
            self.input.value = '';
            self.input.focus();
            self.renderIdle();
          }
          return;
        }
        var termTile = event.target.closest('[data-search-term]');
        if (termTile && self.isOpen()) {
          /* Let navigation happen; optional fill */
        }
      });

      if (this.input) {
        this.input.addEventListener('input', function () {
          self.onQuery(self.input.value);
        });
        this.input.addEventListener('keydown', function (event) {
          if (event.key === 'Escape') self.close();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && self.isOpen()) self.close();
      });
      document.addEventListener('ras:discover:close', this.close.bind(this));
      document.addEventListener('ras:drawer:open', this.close.bind(this));
      document.addEventListener('ras:menu:open', this.close.bind(this));
    }

    SearchDiscover.prototype.isOpen = function () {
      return this.el.classList.contains('is-open');
    };

    SearchDiscover.prototype.open = function (seed) {
      this.lastFocused = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ras-discover-open');
      if (this.input) {
        this.input.value = seed || '';
        this.onQuery(this.input.value);
        var input = this.input;
        window.setTimeout(function () {
          input.focus();
          try { input.setSelectionRange(input.value.length, input.value.length); } catch (err) {}
        }, 80);
      }
    };

    SearchDiscover.prototype.close = function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('ras-discover-open');
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
    };

    SearchDiscover.prototype.renderIdle = function () {
      if (this.idle) this.idle.hidden = false;
      if (this.results) this.results.hidden = true;
      if (this.clearBtn) this.clearBtn.hidden = true;
      if (this.resultsList) this.resultsList.innerHTML = '';
    };

    SearchDiscover.prototype.onQuery = function (raw) {
      var query = (raw || '').trim();
      if (this.clearBtn) this.clearBtn.hidden = !query;
      if (this.seeAll) {
        this.seeAll.href =
          (RAS.routes.search_url || '/search') +
          '?q=' + encodeURIComponent(query) +
          '&type=product&options%5Bprefix%5D=last';
      }

      if (!query) {
        this.renderIdle();
        return;
      }

      if (this.idle) this.idle.hidden = true;
      if (this.results) this.results.hidden = false;
      if (this.resultsLabel) this.resultsLabel.textContent = 'Searching “' + query + '”…';

      var self = this;
      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(function () {
        self.fetchResults(query);
      }, 220);
    };

    SearchDiscover.prototype.fetchResults = function (query) {
      var self = this;
      var endpoint = RAS.routes.predictive_search_url || '/search/suggest';
      var url =
        endpoint +
        '?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&section_id=predictive-search';

      /* Prefer Shopify JSON predictive search API */
      var jsonUrl =
        endpoint +
        '.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8';

      fetch(jsonUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('search failed');
          return response.json();
        })
        .then(function (data) {
          var products =
            (data && data.resources && data.resources.results && data.resources.results.products) ||
            [];
          self.renderResults(query, products);
          try {
            if (typeof RAS.logSearch === 'function') {
              RAS.logSearch(query, products.length);
            }
          } catch (e) {
            console.error('[Search Log] Failed to log query:', e);
          }
        })
        .catch(function () {
          if (self.resultsLabel) self.resultsLabel.textContent = 'Could not load suggestions';
          if (self.resultsList) {
            self.resultsList.innerHTML =
              '<p class="ras-discover__empty">Try a different spelling, or see all results.</p>';
          }
        });
    };

    SearchDiscover.prototype.renderResults = function (query, products) {
      if (this.resultsLabel) {
        this.resultsLabel.textContent = products.length
          ? 'Results for “' + query + '”'
          : 'No matches for “' + query + '”';
      }
      if (!this.resultsList) return;

      if (!products.length) {
        this.resultsList.innerHTML =
          '<p class="ras-discover__empty">Nothing matched. Try another term or browse the suggestions above.</p>';
        return;
      }

      this.resultsList.innerHTML = products
        .map(function (product) {
          var image =
            (product.image ||
              (product.featured_image && (product.featured_image.url || product.featured_image)) ||
              '') || '';
          var price = product.price || product.price_max || '';
          var url = product.url || '#';
          var title = product.title || '';
          return (
            '<a class="ras-discover__hit" href="' + url + '">' +
              '<span class="ras-discover__hit-media">' +
                (image
                  ? '<img src="' + image + '" alt="" loading="lazy" width="56" height="56">'
                  : '') +
              '</span>' +
              '<span class="ras-discover__hit-body">' +
                '<span class="ras-discover__hit-title"></span>' +
                (price ? '<span class="ras-discover__hit-price"></span>' : '') +
              '</span>' +
            '</a>'
          );
        })
        .join('');

      Array.prototype.forEach.call(this.resultsList.querySelectorAll('.ras-discover__hit'), function (node, index) {
        var product = products[index];
        if (!product) return;
        var title = node.querySelector('.ras-discover__hit-title');
        var price = node.querySelector('.ras-discover__hit-price');
        if (title) title.textContent = product.title || '';
        if (price) {
          var raw = product.price || product.price_max || '';
          if (typeof raw === 'number') price.textContent = money(raw);
          else if (String(raw).charAt(0) === '$' || String(raw).indexOf('.') !== -1) price.textContent = String(raw);
          else if (/^\d+$/.test(String(raw))) price.textContent = money(Number(raw));
          else price.textContent = String(raw);
        }
      });
    };

    return SearchDiscover;
  })();

  /* -------------------------------------------------------------- bootstrap */
  function init(root) {
    syncSoldOutElements(root);
    (root || document).querySelectorAll('[data-recommendations][data-url]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new Recommendations(el); }
    });
    (root || document).querySelectorAll('[data-cart-drawer]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new CartDrawer(el); }
    });
    (root || document).querySelectorAll('[data-mobile-menu]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new MobileMenu(el); }
    });
    (root || document).querySelectorAll('[data-search-discover]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new SearchDiscover(el); }
    });
    (root || document).querySelectorAll('[data-hero]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new HeroSlideshow(el); }
    });
    (root || document).querySelectorAll('[data-variant-picker]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new VariantPicker(el); }
    });
    (root || document).querySelectorAll('[data-gallery]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new Gallery(el); }
    });
    (root || document).querySelectorAll('[data-filter-tabs]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new FilterTabs(el); }
    });
    (root || document).querySelectorAll('[data-facet-form]').forEach(function (el) {
      if (!el.rasBound) { el.rasBound = true; new FacetForm(el); }
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });

  /* Theme editor: re-bind when a section is re-rendered. */
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:select', function (event) { init(event.target); });

  /* Drawer open triggers anywhere in the page. */
  document.addEventListener('click', function (event) {
    var back = event.target.closest('[data-nav-back]');
    if (back) {
      event.preventDefault();
      var fallback = back.getAttribute('data-nav-fallback') || '/';
      if (window.history.length > 1) {
        window.history.back();
      } else {
        window.location.href = fallback;
      }
      return;
    }

    if (event.target.closest('[data-explore-open], [data-ai-open]')) return;

    var menuTrigger = event.target.closest('[data-menu-open]');
    if (menuTrigger) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('ras:menu:open'));
      return;
    }

    var trigger = event.target.closest('[data-drawer-open]');
    if (!trigger) return;
    if (RAS.cartType !== 'drawer') return;
    event.preventDefault();
    document.dispatchEvent(new CustomEvent('ras:drawer:open'));
  });

  /* ----------------------------------------------------- smooth page hops */
  function prefersReducedMotionNav() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (err) {
      return false;
    }
  }

  function hasNativePageTransitions() {
    try {
      return 'CSSViewTransitionRule' in window;
    } catch (err) {
      return false;
    }
  }

  function sameOriginUrl(href) {
    try {
      var url = new URL(href, window.location.href);
      return url.origin === window.location.origin;
    } catch (err) {
      return false;
    }
  }

  function shouldAnimateNav(anchor, event) {
    if (!anchor || event.defaultPrevented) return false;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    if (anchor.getAttribute('href') === '#') return false;
    if (
      anchor.closest(
        '[data-drawer-open], [data-explore-open], [data-ai-open], [data-menu-open], [data-search-open], [data-explore-close], [data-ai-close], [data-drawer-close], [data-search-close]'
      )
    ) {
      return false;
    }
    var href = anchor.getAttribute('href');
    if (!href || href.charAt(0) === '#') return false;
    if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return false;
    if (!sameOriginUrl(href)) return false;

    var next = new URL(href, window.location.href);
    var here = window.location;
    if (next.pathname === here.pathname && next.search === here.search && next.hash) return false;
    if (next.href === here.href) return false;
    return true;
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.button !== 0) return;
      if (prefersReducedMotionNav()) return;
      /* Chromium: @view-transition { navigation: auto } handles this */
      if (hasNativePageTransitions()) return;

      var anchor = event.target.closest('a[href]');
      if (!shouldAnimateNav(anchor, event)) return;

      event.preventDefault();
      document.documentElement.classList.add('is-page-exit');
      window.setTimeout(function () {
        window.location.assign(anchor.href);
      }, 200);
    },
    true
  );

  window.addEventListener('pageshow', function (event) {
    document.documentElement.classList.remove('is-page-exit');
    if (event.persisted) {
      var main = document.getElementById('MainContent');
      if (main) {
        main.style.animation = 'none';
        void main.offsetWidth;
        main.style.animation = '';
      }
    }
  });

  /* ----------------------------------------------------------- product share */
  document.addEventListener('click', function (event) {
    var shareBtn = event.target.closest('[data-share-product]');
    if (!shareBtn) return;
    event.preventDefault();
    var shareData = {
      title: document.title,
      url: window.location.href
    };
    if (navigator.share) {
      navigator.share(shareData).catch(function () { /* cancelled */ });
      return;
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(shareData.url).then(function () {
        announce('Link copied');
      });
    }
  });

  /* Sticky PDP top bar title on scroll */
  function initPdpChrome() {
    var chrome = document.querySelector('[data-pdp-chrome]');
    var titleEl = document.querySelector('.ras-product__title');
    if (!chrome) return;

    var threshold = 120;
    if (titleEl) {
      threshold = Math.max(80, titleEl.getBoundingClientRect().top + window.scrollY - 56);
    }

    function sync() {
      chrome.classList.toggle('is-stuck', window.scrollY > threshold);
    }
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  }

  function logPageSearch() {
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q');
    if (query && query.trim() !== '') {
      // Avoid duplicate logging if predictive search already logged it within the last 5 seconds
      var lastQuery = sessionStorage.getItem('ras-last-logged-search');
      var lastTime = Number(sessionStorage.getItem('ras-last-logged-search-time') || 0);
      var now = Date.now();
      if (lastQuery === query && (now - lastTime) < 5000) return;

      sessionStorage.setItem('ras-last-logged-search', query);
      sessionStorage.setItem('ras-last-logged-search-time', String(now));

      if (typeof RAS.logSearch === 'function') {
        // Find total product card results on the page to store as count if available
        var countEl = document.querySelector('[data-search-count]');
        var count = countEl ? parseInt(countEl.textContent || '0', 10) : null;
        RAS.logSearch(query, count);
      }
    }
  }

  /* ---------------------------------------------------- desktop search dropdown */
  function DesktopSearch(form) {
    if (!form) return;
    this.form = form;
    this.input = form.querySelector('[data-desktop-search-input]');
    this.dropdown = form.querySelector('[data-desktop-search-dropdown]');
    this.list = form.querySelector('[data-desktop-search-list]');
    this.label = form.querySelector('[data-desktop-search-label]');
    this.seeAll = form.querySelector('[data-desktop-search-see-all]');
    
    if (!this.input || !this.dropdown) return;
    
    this.timer = null;
    this.init();
  }

  DesktopSearch.prototype.init = function () {
    var self = this;
    
    this.input.addEventListener('input', function () {
      var query = (self.input.value || '').trim();
      window.clearTimeout(self.timer);
      
      if (!query) {
        self.close();
        return;
      }
      
      self.timer = window.setTimeout(function () {
        self.fetch(query);
      }, 200);
    });

    this.input.addEventListener('focus', function () {
      var query = (self.input.value || '').trim();
      if (query) self.fetch(query);
    });

    // Close when clicking outside
    document.addEventListener('click', function (event) {
      if (!self.form.contains(event.target)) {
        self.close();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        self.close();
        self.input.blur();
      }
    });
  };

  DesktopSearch.prototype.close = function () {
    this.dropdown.hidden = true;
  };

  DesktopSearch.prototype.fetch = function (query) {
    var self = this;
    if (this.label) this.label.textContent = 'Searching...';
    this.dropdown.hidden = false;
    
    var endpoint = RAS.routes.predictive_search_url || '/search/suggest';
    var url = endpoint + '.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=5';
    
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Search failed');
        return response.json();
      })
      .then(function (data) {
        var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
        self.render(query, products);
        
        // Log to D1 database asynchronously
        try {
          if (typeof RAS.logSearch === 'function') {
            RAS.logSearch(query, products.length);
          }
        } catch (err) {
          console.error('[Search Log] Failed to log desktop query:', err);
        }
      })
      .catch(function () {
        if (self.label) self.label.textContent = 'No suggestions found';
      });
  };

  DesktopSearch.prototype.render = function (query, products) {
    if (this.label) {
      this.label.textContent = products.length ? 'Instant matches' : 'No matches found';
    }
    
    if (this.seeAll) {
      this.seeAll.href = (RAS.routes.search_url || '/search') + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last';
      this.seeAll.hidden = !products.length;
    }
    
    if (!this.list) return;
    this.list.innerHTML = '';
    
    if (!products.length) return;
    
    this.list.innerHTML = products.map(function (p) {
      var image = p.image || (p.featured_image && (p.featured_image.url || p.featured_image)) || '';
      var imgTag = image ? '<img src="' + image + '" alt="" width="44" height="44" loading="lazy">' : '<span class="ras-search__dropdown-hit-ph"></span>';
      var price = p.price || p.price_max || '';
      var url = p.url || '#';
      var title = p.title || '';
      
      return '<a class="ras-search__dropdown-hit" href="' + url + '">' +
             imgTag +
             '<span class="ras-search__dropdown-hit-body">' +
               '<span class="ras-search__dropdown-hit-title">' + title + '</span>' +
               '<span class="ras-search__dropdown-hit-price">' + price + '</span>' +
             '</span>' +
             '</a>';
    }).join('');
  };

  // Handle click on vendor-specific checkout button to redirect to permalink checkout
  document.addEventListener('click', function (event) {
    var checkoutBtn = event.target.closest('[data-vendor-checkout-btn]');
    if (!checkoutBtn) return;
    
    var vendor = checkoutBtn.getAttribute('data-vendor-checkout-btn');
    if (!vendor) return;
    
    var lines = document.querySelectorAll('[data-line-item]');
    var permalinkParts = [];
    lines.forEach(function (line) {
      var lineVendor = line.getAttribute('data-vendor');
      var variantId = line.getAttribute('data-variant-id');
      var input = line.querySelector('[data-line-key]');
      var qty = input ? Number(input.value) : 1;
      
      if (lineVendor === vendor && variantId && qty > 0) {
        permalinkParts.push(variantId + ':' + qty);
      }
    });
    
    if (permalinkParts.length > 0) {
      event.preventDefault();
      var form = checkoutBtn.closest('form');
      var noteQuery = '';
      if (form) {
        var noteElement = form.querySelector('[name="note"]');
        if (noteElement && noteElement.value) {
          noteQuery = '?note=' + encodeURIComponent(noteElement.value);
        }
      }
      var checkoutUrl = '/cart/' + permalinkParts.join(',') + noteQuery;
      window.location.href = checkoutUrl;
    }
  });

  var VENDOR_LOCATIONS = {
    "Vendor A": { lat: 40.7128, lng: -74.0060 }, // New York
    "Vendor B": { lat: 34.0522, lng: -118.2437 }, // Los Angeles
    "Vendor C": { lat: 41.8781, lng: -87.6298 }  // Chicago
  };

  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  function calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of earth in km
    var dLat = deg2rad(lat2 - lat1);
    var dLon = deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  }

  function getShippingFeeForDistance(distanceKm) {
    if (distanceKm < 15) return 500; // Under 15 km = $5.00
    if (distanceKm < 50) return 1000; // Under 50 km = $10.00
    if (distanceKm < 200) return 2000; // Under 200 km = $20.00
    return 4000; // Long distance = $40.00
  }

  function updateCartShippingDistances(lat, lng, locationText) {
    var textEl = document.querySelector('[data-location-text]');
    if (textEl && locationText) {
      textEl.textContent = 'Delivering to: ' + locationText;
    }

    var vendorGroups = document.querySelectorAll('[data-vendor-group]');
    vendorGroups.forEach(function (group) {
      var vendorName = group.getAttribute('data-vendor-group');
      var vendorLoc = VENDOR_LOCATIONS[vendorName] || VENDOR_LOCATIONS["Vendor A"]; // Fallback to Vendor A
      
      var distance = calculateDistance(lat, lng, vendorLoc.lat, vendorLoc.lng);
      var distanceStr = '(' + distance.toFixed(1) + ' km)';
      
      var distanceLabel = group.querySelector('[data-vendor-distance-label]');
      if (distanceLabel) {
        distanceLabel.textContent = distanceStr;
      }
      
      var shippingFee = getShippingFeeForDistance(distance);
      var shippingLabel = group.querySelector('[data-vendor-shipping-fee]');
      if (shippingLabel) {
        shippingLabel.textContent = money(shippingFee);
      }
      
      var subtotalEl = group.querySelector('[data-vendor-subtotal]');
      if (subtotalEl) {
        var subtotal = Number(subtotalEl.getAttribute('data-vendor-subtotal') || 0);
        var total = subtotal + shippingFee + 99; // Adds the $0.99 surcharge
        var totalEl = group.querySelector('[data-vendor-total-price]');
        if (totalEl) {
          totalEl.textContent = money(total);
        }
      }
    });
  }

  function initLocationDetection() {
    var storedCoords = sessionStorage.getItem('customer_coords');
    var storedText = sessionStorage.getItem('customer_location_text');
    
    if (storedCoords && storedText) {
      var coords = JSON.parse(storedCoords);
      updateCartShippingDistances(coords.lat, coords.lng, storedText);
    } else {
      // Fetch IP-based location automatically
      fetch('https://ipapi.co/json/')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data.latitude && data.longitude) {
            var coords = { lat: data.latitude, lng: data.longitude };
            var locText = data.city + ', ' + (data.region_code || data.region || data.country_name);
            sessionStorage.setItem('customer_coords', JSON.stringify(coords));
            sessionStorage.setItem('customer_location_text', locText);
            updateCartShippingDistances(coords.lat, coords.lng, locText);
          }
        })
        .catch(function () {
          // Fallback if IP lookup fails
          var textEl = document.querySelector('[data-location-text]');
          if (textEl) textEl.textContent = 'Deliver to: Enter Zip / Allow Location';
        });
    }

    // Set up Refine / Click Location button handler
    var detectBtn = document.querySelector('[data-detect-location-btn]');
    if (detectBtn) {
      detectBtn.addEventListener('click', function () {
        if (navigator.geolocation) {
          detectBtn.textContent = 'Updating...';
          navigator.geolocation.getCurrentPosition(function (position) {
            var coords = { lat: position.coords.latitude, lng: position.coords.longitude };
            sessionStorage.setItem('customer_coords', JSON.stringify(coords));
            sessionStorage.setItem('customer_location_text', 'Current Location');
            updateCartShippingDistances(coords.lat, coords.lng, 'Current Location');
            detectBtn.textContent = 'Refine';
          }, function () {
            // If GPS permission is blocked/denied, fallback to prompt
            var zip = prompt('Please enter your city name or ZIP code:');
            if (zip) {
              sessionStorage.setItem('customer_location_text', zip);
              // Fallback coords to Chicago center if they entered manual zip for distance relative point
              var coords = { lat: 41.8781, lng: -87.6298 }; 
              sessionStorage.setItem('customer_coords', JSON.stringify(coords));
              updateCartShippingDistances(coords.lat, coords.lng, zip);
            }
            detectBtn.textContent = 'Refine';
          });
        }
      });
    }
  }

  document.addEventListener('ras:cart:update', function () {
    setTimeout(initLocationDetection, 50);
  });

  function initMegaMenuTabs() {
    var megaMenus = document.querySelectorAll('[data-mega-menu]');
    megaMenus.forEach(function (megaMenu) {
      var tabs = megaMenu.querySelectorAll('[data-tab-target]');
      var panels = megaMenu.querySelectorAll('[data-tab-panel]');
      if (!tabs.length || !panels.length) return;

      function switchTab(targetId) {
        tabs.forEach(function (tab) {
          if (tab.getAttribute('data-tab-target') === targetId) {
            tab.classList.add('is-active');
          } else {
            tab.classList.remove('is-active');
          }
        });

        panels.forEach(function (panel) {
          if (panel.getAttribute('data-tab-panel') === targetId) {
            panel.classList.add('is-active');
          } else {
            panel.classList.remove('is-active');
          }
        });
      }

      tabs.forEach(function (tab) {
        var targetId = tab.getAttribute('data-tab-target');
        tab.addEventListener('mouseenter', function () {
          switchTab(targetId);
        });
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          switchTab(targetId);
        });
      });
    });
  }

  function initPage() {
    initPdpChrome();
    logPageSearch();
    initLocationDetection();
    initMegaMenuTabs();
    
    var desktopForm = document.querySelector('[data-desktop-search-form]');
    if (desktopForm) {
      new DesktopSearch(desktopForm);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPage);
  } else {
    initPage();
  }
})();
